import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges
} from '@angular/core';
import {
	DoubleBookingParsed,
	DoubleBookingParsedEvent
} from '@models/double-booking.model';
import { DoubleBookingService } from '@services/double-booking/double-booking.service';
import { SNModalService } from '@web-services/modal/snModal.service';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { AlertAction } from '@models/models';

@Component({
	selector: 'events-overlapping-info',
	template: require('./events-overlapping-info.component.html'),
	styles: [require('./events-overlapping-info.component.scss')]
})
export class EventsOverlappingInfoComponent implements OnInit, OnChanges {
	@Input() data: DoubleBookingParsed;
	companiesList: Array<string>;
	dataToShow: DoubleBookingParsed;

	constructor(
		private doubleBookingService: DoubleBookingService,
		private modalService: SNModalService
	) {}

	ngOnInit(): void {
		if (this.data) {
			this.createDoubleBookingDataToShow();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.data.isFirstChange() && changes.data.currentValue) {
			this.createDoubleBookingDataToShow();
		}
	}

	reactToEventClick($event: DoubleBookingParsedEvent): void {
		const { OPEN_TAB } = $event.actions;
		if (OPEN_TAB) {
			const { method, url, alertMessage } = OPEN_TAB;

			if (method === 'NEW_WINDOW') {
				window.open(url, '_blank');
			}

			if (method === 'ALERT_MODAL') {
				document.body.classList.remove('modal-open');
				this.openAlertModal(alertMessage).result.then((): void =>
					document.body.classList.add('modal-open')
				);
			}
		}
	}

	shouldShowCompanyName(company: string): boolean {
		return (
			this.companiesList.length > 1 ||
			(this.companiesList.length === 1 &&
				this.dataToShow.events[company].length > 1 &&
				!this.dataToShow.events[company][0].company.currentBrand)
		);
	}

	private createDoubleBookingDataToShow(): void {
		const { events } = this.doubleBookingService.sortDoubleBookingEvents(
			this.data
		);
		this.dataToShow = { ...this.data, events };
		this.companiesList = this.doubleBookingService.sortBrands(
			Object.keys(this.data.events),
			this.dataToShow
		);
		this.removeJobTypes();
	}

	private removeJobTypes(): void {
		this.companiesList.forEach((company: string): void => {
			this.dataToShow.events[company] = this.dataToShow.events[company].map(
				(event: DoubleBookingParsedEvent): DoubleBookingParsedEvent => ({
					...event,
					jobType: null
				})
			);
		});
	}

	private openAlertModal(alert: AlertAction): NgbModalRef {
		const { message, title } = alert;
		const modal = this.modalService.openModal(ConfirmGeneralModalComponent, {
			windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
		});

		if (title) {
			modal.componentInstance.title = title;
		}

		modal.componentInstance.text = message;

		modal.componentInstance.buttons = [
			{
				text: 'Got it',
				action: 'CLOSE',
				color: 'default',
				size: 'lg'
			}
		];

		return modal;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.ts